module.exports = __webpack_public_path__ + "static/media/BaraKKa and Loretto.58b16330.pdf";